export const watchlistTypes = {
    TOGGLE_SELECT_PLAYER: 'WATCHLIST_TOGGLE_SELECT_PLAYER',
    SET_PAGINATION: 'WATCHLIST_SET_PAGINATION',

    SET_SEARCH_VALUE: 'WATCHLIST_SET_SEARCH_VALUE',
    SET_TEMP_SEARCH_VALUE: 'WATCHLIST_SET_TEMP_SEARCH_VALUE',

    SET_EXPAND_ROW: 'WATCHLIST_SET_EXPAND_ROW',
    SET_EMPTY: 'WATCHLIST_SET_EMPTY',
    SET_ORDER: 'WATCHLIST_SET_ORDER',
    REMOVE_SELECTED_PLAYERS: 'WATCHLIST_REMOVE_SELECTED_PLAYERS',

    CLEAR_SELECTIONS: 'WATCHLIST_CLEAR_SELECTIONS',
    SET_REFETCH: 'WATCHLIST_SET_REFETCH',
};
